import {CellsContext} from '../../../libs/shared/core/src/store/panels/cells/context/cellsContext';
import {ConversationSearchResultModel} from '../../models/api/conversationSearchResultModel';
import {isTrackerUnsnoozed} from '../modelHelpers';
import {isConversationInTeamContext, pickUnreadStatus} from './conversationHelpers';

export function findUnreadStatusForConversationSearchResult(
  cellsContext: CellsContext,
  conversationSearchResult: ConversationSearchResultModel,
) {
  const {teammateId} = cellsContext;
  const isInTeamContext = isConversationInTeamContext(cellsContext, conversationSearchResult);

  // Tracker unsnoozed.
  const tracker = conversationSearchResult.trackers[teammateId];
  const isTrackerSnoozeUnread = isTrackerUnsnoozed(conversationSearchResult, tracker);

  // Team unsnoozed.
  const isTeamSnoozeUnread =
    conversationSearchResult.isUnsnoozed &&
    !conversationSearchResult.teamUnsnoozedSeenByIds.includes(teammateId);

  // Message unread.
  const isMessageUnread = !conversationSearchResult.readByIds.includes(teammateId);

  return pickUnreadStatus(isInTeamContext, isTrackerSnoozeUnread, isTeamSnoozeUnread, isMessageUnread);
}
